export const SESSION_PATHS = {
  ROOT: "/user",
  LOGIN_WITH_PASSWORD: "/user/login",
  LOGIN_WITH_SSO: "/user/login-sso",
  LOGIN_WITH_MFA: "/user/login/mfa",
  MFA_REQUIRED: "/user/mfa-required",
  FORGOT_PASSWORD: "/user/forgot-password",
} as const;
